import React from 'react';
import * as $ from 'jquery';
import { connect } from 'react-redux';
import { Line } from 'rc-progress';

import { generalActions } from '../actions';

import { generalConstants } from '../constants';
import { TextInput, TextArea, ImageInput } from '../components';

import imageloading from '../assets/img/loading.gif';
class ImageUploader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      file: {
        name: '',
        type: '',
        size: '',
        data: {
          url: '',
          title: '',
          description: '',
          alt: ''
        }
      },
      loading: false,
      percent: 0
    };

    this.addFile = this.addFile.bind(this);
    this.browseFile = this.browseFile.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.editFile = this.editFile.bind(this);
    this.saveFile = this.saveFile.bind(this);
    this.onloadimage = this.onloadimage.bind(this);
    this.increase = this.increase.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.upload.data) {
      this.setState({ file: newProps.upload.data.data });
    } else {
      this.setState({
        file: {
          name: '',
          type: '',
          size: '',
          data: {
            url: '',
            title: '',
            description: '',
            alt: ''
          }
        }
      });
    }
  }

  //function for open Modal
  addFile() {
    const { dispatch } = this.props;
    dispatch(generalActions.clearUpload());

    $('#ImageUploader').modal('show');
  }

  //function for open file browser
  browseFile(e) {
    e.preventDefault();

    this.refs.browseFile.click();
  }

  //function for upload file to api
  uploadFile(e) {
    e.preventDefault();

    const { dispatch, upload } = this.props;
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();

      formData.set('file', file, file.name);

      if (formData) {
        this.setState({ loading: true }, () => {
          this.increase();
        });
        dispatch(generalActions.postUpload(formData));
        //this.increase();
      }
    }
  }

  //function for edit text
  editFile(e) {
    const { file } = this.state;
    const { data } = file;
    const { name, value } = e.target;
    this.setState({ file: { ...file, data: { ...data, [name]: value } } });
  }

  //function for save modal
  saveFile(e) {
    e.preventDefault();

    const { dispatch, upload, editorState, onChange, modifier } = this.props;

    //props modifier berasal dari imageuploader yg menggunakan draftjs
    if (modifier) {
      onChange(modifier(editorState, upload.data.data.file));
    }
    dispatch(generalActions.saveUpload({ data: this.state.file }));
    this.increase();
  }

  onloadimage() {
    this.setState({ percent: 0, loading: false });
  }

  increase() {
    const percent = this.state.percent + 1;
    if (percent >= 100) {
      clearTimeout(this.tm);
      return;
    }
    this.setState({ percent });
    this.tm = setTimeout(this.increase, 100);
  }

  render() {
    const { upload } = this.props;

    const imgStyle = {
      height: '100%',
      width: '100%'
    };

    const file = this.state.file;

    return (
      <div>
        <button type="button" className="btn btn-success" onClick={this.addFile}>
          <i className="fa fa-plus" />
        </button>

        <div className="modal fade" id="ImageUploader">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Modal Heading</h4>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              <div className="modal-body">
                <div className="form-group">
                  <div className="form-group">
                    <label className="form-control-label">Image</label>
                    <input
                      type="file"
                      ref="browseFile"
                      name="file"
                      style={{ display: 'none' }}
                      onChange={this.uploadFile}
                    />
                    {this.state.loading ? (
                      <Line strokeWidth="4" percent={this.state.percent} />
                    ) : (
                      <div />
                    )}
                    <div className="d-block clearfix">
                      <button
                        className={
                          'uploader-img' + (file.name !== '' ? ' uploader-img-filled' : '')
                        }
                        onClick={this.browseFile}
                      >
                        {file.name !== '' ? (
                          <img
                            src={generalConstants.BASE_URL + file.data.url}
                            style={imgStyle}
                            className="img-fluid"
                            alt="Image Uploaded"
                            onLoad={this.onloadimage}
                          />
                        ) : (
                          <div className="icon">
                            <i className="fal fa-arrow-alt-circle-up" />
                          </div>
                        )}
                      </button>
                    </div>
                  </div>
                  {this.props.options == 'teksEditor' ? (
                    <div />
                  ) : (
                    <div>
                      <TextInput
                        input_label="Title"
                        input_placeholder="Enter Title"
                        input_name="title"
                        input_type="text"
                        input_onChange={this.editFile}
                        input_value={file.data.title}
                      />

                      <TextArea
                        input_label="Description"
                        input_placeholder="Enter description text"
                        input_rows="4"
                        input_name="description"
                        input_type="text"
                        input_onChange={this.editFile}
                        input_value={file.data.description}
                      />

                      <TextInput
                        input_label="Alt"
                        input_placeholder="Enter Alt"
                        input_name="alt"
                        input_type="text"
                        input_onChange={this.editFile}
                        input_value={file.data.alt}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  data-dismiss="modal"
                  onClick={this.saveFile}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

var Meter = function(props) {
  var {
    percent = 0, // a number between 0 and 1, inclusive
    width = 100, // the overall width
    height = 10, // the overall height
    rounded = true, // if true, use rounded corners
    color = '#0078bc', // the fill color
    animate = false, // if true, animate when the percent changes
    label = null // a label to describe the contents (for accessibility)
  } = props;

  var r = rounded ? Math.ceil(height / 2) : 0;
  var w = percent ? Math.max(height, width * Math.min(percent, 1)) : 0;
  var style = animate ? { transition: 'width 500ms, fill 250ms' } : null;

  return (
    <svg width={width} height={height} aria-label={label}>
      <rect width={width} height={height} fill="#ccc" rx={r} ry={r} />
      <rect width={w} height={height} fill={color} rx={r} ry={r} style={style} />
    </svg>
  );
};

function mapStateToProps(state) {
  const { upload } = state.general;
  return {
    upload
  };
}

const connectedImageUploader = connect(mapStateToProps)(ImageUploader);
export { connectedImageUploader as ImageUploader };



// WEBPACK FOOTER //
// ./src/components/ImageUploader.js